import { styled } from '@mui/material';

const Form = styled('form')`
margin: auto 0;
`;

export default Form;
